<template>
  <div>
    <top-bar heading="Submissions"></top-bar>
    <div class="container-fluid mt-3">
      <b-card>
        <vue-good-table
                mode="remote"
                :columns="columns"
                :rows="submissions.data"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                :pagination-options="paginationOptions"
                :isLoading="loading"
                :total-rows="totalRecords"
        >
          <template slot="table-row" slot-scope="props">
            <span class="text-center" v-if="props.column.field === 'grade_status'">
                <span class="badge badge-success p-2 pl-3 pr-3" v-if="props.row.grade_status === 1">Satisfactory</span>
                <span class="badge badge-danger p-2 pl-3 pr-3" v-if="props.row.grade_status === 0">Unsatisfactory</span>
                <span class="badge badge-primary p-2 pl-3 pr-3" v-if="props.row.grade_status === 2">Awaiting Grading</span>
              </span>
            <span v-else-if="props.column.field === 'actions'">
              <div class="btn-group">
                <b-button variant="success" :to="'/submissions/' + props.row.id"><font-awesome-icon icon="eye"></font-awesome-icon></b-button>
              </div>
            </span>
            <span v-else-if="props.column.field === 'user.name_full'">
              <router-link :to="'/users/'+props.row.user.id+'/progression'">{{ props.row.user.name_full }}</router-link>
            </span>
            <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
          </template>
        </vue-good-table>
      </b-card>
    </div>
  </div>
</template>

<script>
import forEach from 'lodash-es/forEach'
import URI from 'urijs'

export default {
  name: 'Submissions',
  data () {
    return {
      submissions: {
        meta: {
          current_page: 1,
          per_page: 10
        },
        data: []
      },
      columns: [
        {
          field: 'form_name',
          label: 'Form',
          filterOptions: {
            enabled: true,
            filterValue: this.$route.query['filter[form_name]'] || null
          }
        },
        {
          field: 'user.name_full',
          label: 'Student',
          sortable: false,
          filterOptions: {
            enabled: true,
            filterValue: this.$route.query['filter[user.name_full]'] || null
          }
        },
        {
          field: 'created_at',
          label: 'Submitted'
        },
        {
          field: 'grade_status',
          label: 'Status',
          filterOptions: {
            enabled: true,
            filterDropdownItems: [
              { value: 2, text: 'Awaiting Grading' },
              { value: 1, text: 'Satisfactory' },
              { value: 0, text: 'Unsatisfactory' }
            ],

            filterValue: this.$route.query['filter[grade_status]'] || null
          }
        },
        {
          field: 'actions',
          label: 'Actions'
        }
      ],
      loading: true,
      serverParams: {
        columnFilters: {},
        sort: {
          field: this.$route.query.sortBy || 'updated_at',
          type: this.$route.query.sort || 'desc'
        },
        page: this.$route.query.page || 1,
        perPage: this.$route.query.limit || 10
      }
    }
  },
  methods: {
    updateParams (newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },

    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.getSubmissions()
    },

    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.getSubmissions()
    },

    onSortChange (params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      this.getSubmissions()
    },

    onColumnFilter (params) {
      this.updateParams(params)
      this.getSubmissions()
    },

    getSubmissions () {

      let params = {
        page: this.serverParams.page,
        limit: this.serverParams.perPage,
        sortBy: (this.serverParams.sort.field === 'user.name_full') ? 'users.name_full' : this.serverParams.sort.field,
        sort: this.serverParams.sort.type
      }

      forEach(this.serverParams.columnFilters, (value, index) => {
        params['filter[' + index + ']'] = value
      })

      this.$router.push('/submissions?' + new URI('').search(params))

      this.loading = true
      this.axios.get('submissions', { params }).then((rsp) => {

        rsp.data.data = rsp.data.data.map(submission => {
          submission.created_at = this.$moment(submission.created_at).format('MMM Do YYYY, h:mm a')

          return submission
        })

        this.submissions = rsp.data

        this.loading = false
      })
    }
  },
  computed: {
    paginationOptions () {
      return {
        enabled: true,
        mode: 'records',
        perPage: this.submissions.meta.per_page,
        position: 'bottom',
        dropdownAllowAll: false,
        setCurrentPage: this.submissions.meta.current_page || 1,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Rows per page',
        ofLabel: 'of',
        allLabel: 'All'
      }
    },
    totalRecords () {
      return this.submissions.meta.total || 0
    }
  },
  created () {
    if(!Object.keys(this.$route.query).length) {
      this.getSubmissions()
    }
    //this.getSubmissions()
  },
  metaInfo: {
    title: 'Submissions'
  }
}
</script>
